module.exports = __webpack_public_path__ + "static/finding-gold-028422603493afd4cc89102b2cb692d7.webp";